module.exports = __webpack_public_path__ + "img/poster_2.de467d34.jpg";